import React from "react";
import { GiFlowerPot } from "react-icons/gi";
import CircularImageRow from "../components/CircularImageRow";
import ConciergeInterestForm from "../components/ConciergeInterestForm";

const ConciergePage: React.FC = () => (
  <div
    style={{
      background: "#251529",
      minHeight: "100vh",
      color: "white",
      fontFamily: "Inter, sans-serif",
    }}
  >
    <div style={{ padding: 22, maxWidth: 900, margin: "0 auto" }}>
      <h2 style={{ 
        fontSize: "1.8rem", 
        fontWeight: "bold", 
        textAlign: "center", 
        marginBottom: "0.5rem",
        background: "linear-gradient(90deg, #a86fd6 0%, #f5e9fb 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent"
      }}>
        Book a WellBnB<span style={{fontSize: '0.6em', verticalAlign: 'super'}}>™</span> Concierge
      </h2>
      <p style={{ 
        textAlign: "center", 
        fontSize: "1.1rem", 
        lineHeight: "1.6", 
        marginBottom: "1.5rem",
        opacity: 0.9
      }}>
        Meet WellBnB<span style={{fontSize: '0.6em', verticalAlign: 'super'}}>™</span> Concierges from all over the world who are ready to
        personalize your wellness programs, access local experts, and help to
        seamlessly elevate your stay with WellBnB<span style={{fontSize: '0.6em', verticalAlign: 'super'}}>™</span>.
      </p>
      
      {/* Decorative dotted line */}
      <div
        style={{
          textAlign: "center",
          margin: "24px auto",
          maxWidth: 500,
        }}
      >
        <div
          style={{
            borderTop: "2px dotted rgba(168, 111, 214, 0.7)",
            width: "100%",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-12px",
              left: "50%",
              transform: "translateX(-50%)",
              background: "#251529",
              padding: "0 20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <GiFlowerPot style={{ fontSize: "1.5rem", color: "#a86fd6" }} />
          </div>
        </div>
      </div>
    </div>
    
    <div style={{ padding: "16px 0 32px 0" }}>
      <div style={{ maxWidth: 900, margin: "0 auto", padding: "0 32px" }}>
        <p style={{ 
          textAlign: "center", 
          maxWidth: 700, 
          margin: "24px auto", 
          fontSize: "1.1rem", 
          lineHeight: "1.7",
          opacity: 0.9
        }}>
          WellBnB™ Concierges are trusted local guides who specialize in creating
          personalized wellness journeys tailored to your specific goals,
          preferences, and intentions.
        </p>
        <p style={{ 
          textAlign: "center", 
          maxWidth: 700, 
          margin: "24px auto", 
          fontSize: "1.1rem", 
          lineHeight: "1.7",
          opacity: 0.9
        }}>
          Each concierge is professionally trained by WellBnB™ to ensure a
          seamless, high-quality, and consistent guest experience—no matter where
          you travel.
        </p>
        <p style={{ 
          textAlign: "center", 
          maxWidth: 700, 
          margin: "24px auto", 
          fontSize: "1.1rem", 
          lineHeight: "1.7",
          opacity: 0.9
        }}>
          They know where the best of the best is offering services, and if
          there's something outside of their certifications and expertise? They'll
          connect you with the most respected wellness practitioners in the area —
          handpicked for quality, integrity, and alignment with your needs.
        </p>
        <p style={{ 
          textAlign: "center", 
          maxWidth: 700, 
          margin: "24px auto", 
          fontSize: "1.1rem", 
          lineHeight: "1.7",
          opacity: 0.9
        }}>
          From yoga and sound healing to massage, cold plunges, and spa rituals —
          they're here to elevate your wellness.
        </p>
        
        <div style={{
          background: "rgba(168, 111, 214, 0.1)",
          borderRadius: "16px",
          padding: "24px",
          margin: "32px auto",
          maxWidth: 700,
          border: "1px solid rgba(168, 111, 214, 0.2)"
        }}>
          <p style={{ 
            textAlign: "center", 
            margin: "0 0 16px 0",
            fontSize: "1.2rem",
            fontWeight: "bold",
            background: "linear-gradient(90deg, #a86fd6 0%, #e0b3ff 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent"
          }}>
            Available Wellness Modalities:
          </p>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "8px",
            marginTop: "16px"
          }}>
            {[
              "Yoga",
              "Massage Spa Services",
              "Sauna + Cold Plunge", 
              "Sound Healing",
              "Energy Healing",
              "Light + Laser Therapies"
            ].map((modality, index) => (
              <div key={index} style={{
                padding: "8px 16px",
                background: "rgba(168, 111, 214, 0.2)",
                borderRadius: "20px",
                textAlign: "center",
                fontSize: "0.95rem"
              }}>
                {modality}
              </div>
            ))}
          </div>
        </div>
        
        <p style={{ 
          textAlign: "center", 
          maxWidth: 700, 
          margin: "24px auto", 
          fontSize: "1.1rem", 
          lineHeight: "1.7",
          opacity: 0.9,
          fontStyle: "italic"
        }}>
          ...or ask us specifically for what you're looking for, and we will find
          it for you!
        </p>
        
        <div style={{ margin: "40px 0" }}>
          <CircularImageRow
            images={[
              { src: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=200&h=200&fit=crop&crop=face", alt: "Concierge" },
              { src: "https://images.unsplash.com/photo-1593811167562-9cef47bfc4d7?w=200&h=200&fit=crop", alt: "Sound Healing" },
              { src: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=200&h=200&fit=crop", alt: "Yoga" },
              { src: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=200&h=200&fit=crop", alt: "Retreats" },
              { src: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=200&h=200&fit=crop", alt: "Spa" },
            ]}
          />
        </div>
        
        <h2 style={{
          textAlign: "center",
          fontSize: "2rem",
          fontWeight: "bold",
          margin: "48px 0 16px 0",
          background: "linear-gradient(90deg, #a86fd6 0%, #e0b3ff 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent"
        }}>
          Become a WellBnB<span style={{fontSize: '0.6em', verticalAlign: 'super'}}>™</span> Concierge!
        </h2>
        
        {/* Decorative dotted line */}
        <div
          style={{
            textAlign: "center",
            margin: "16px auto 32px auto",
            maxWidth: 400,
          }}
        >
          <div
            style={{
              borderTop: "2px dotted rgba(168, 111, 214, 0.6)",
              width: "100%",
              position: "relative",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "-12px",
                left: "50%",
                transform: "translateX(-50%)",
                background: "#251529",
                padding: "0 20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <GiFlowerPot style={{ fontSize: "1.2rem", color: "#a86fd6" }} />
            </div>
          </div>
        </div>
        <p style={{ 
          textAlign: "center", 
          maxWidth: 700, 
          margin: "24px auto", 
          fontSize: "1.1rem", 
          lineHeight: "1.7",
          opacity: 0.9
        }}>
          At WellBnB™, we're building a global community of wellness enthusiasts
          who live to inspire and uplift. Whether you dream of becoming a yoga
          teacher, sculpt instructor, meditation guide, sound facilitator, or
          energy healer, we'll give you the training and tools to grow.
        </p>
        <p style={{ 
          textAlign: "center", 
          maxWidth: 700, 
          margin: "24px auto", 
          fontSize: "1.1rem", 
          lineHeight: "1.7",
          opacity: 0.9
        }}>
          Our online trainings, offered once a month, make it easy to learn from
          anywhere—and connect you with like-minded souls around the world. Step
          into your purpose, expand your skills, and join our movement to bring
          wellness wherever people travel.
        </p>
        <p style={{ 
          textAlign: "center", 
          maxWidth: 700, 
          margin: "24px auto", 
          fontSize: "1.1rem", 
          lineHeight: "1.7",
          opacity: 0.9
        }}>
          Already trained? Let us know below! Whether you're certified or just
          starting your journey, someone from WellBnB™ will connect with you soon
          and share everything you need to get started.
        </p>
        <p style={{ 
          textAlign: "center", 
          fontSize: "1.1rem", 
          margin: "32px auto",
          fontWeight: "500"
        }}>
          Use the form below for details on becoming a WellBnB™ Concierge!
        </p>
        <div style={{ marginTop: 32 }}>
          <ConciergeInterestForm />
        </div>
      </div>
    </div>
  </div>
);

export default ConciergePage;